module.exports = __webpack_public_path__ + "img/apfelstrudel.2679331c.png";